import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetCompanyDepositRulesRequestSchema,
  TGetCompanyDepositRulesResponseSchema,
} from "./getCompanyDepositRules.schema";

export const getCompanyDepositRules = (axios: IAxiosInstance) => {
  return async (data: TGetCompanyDepositRulesRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetCompanyDepositRulesResponseSchema>
    >(`/api/deposit-rules/company/${data.companyID}`, {
      params: {
        workerID: data.workerID,
      },
    });

    return response.data;
  };
};
